<template>
  <a
    v-if="isLink(button.action)"
    :href="button.action"
    target="_blank"
    class="button"
  >{{ button.label }}</a>
  <a
    v-else-if="isEmail(button.action) || isPhone(button.action)"
    :href="button.action"
    class="button"
    :class="[
              {'button--clicked': button['clicked']},
              'button--' + (button.color ? button.color : 'content'),
            ]"
  >
    <div class="hover hover0"></div>
    <div class="hover hover1"></div>
    <div class="hover hover2"></div>
    <span class="button-vspace">{{ button.vspace }}</span>
    <span class="button-hspace">{{ button.label }}</span>
    <span class="button-label">{{ button.label }}</span>
  </a>
  <button
    v-else
    @click="onButtonClick(button.action, id)"
    :data-index="clusterIndex"
    class="button"
    :class="[
              {'button--clicked': button['clicked']},
              'button--' + (button.color ? button.color : 'content'),
            ]"
  >
    <div class="hover hover0"></div>
    <div class="hover hover1"></div>
    <div class="hover hover2"></div>
    <span class="button-vspace">{{ button.vspace }}</span>   
    <span class="button-hspace">{{ button.label }}</span>
    <span class="button-label">{{ button.label }}</span>
  </button>
</template>

<script>
export default {
  data() {
    return {
      buttonLabel: ""
    };
  },
  props: ["button", "id", "clusterIndex"],
  computed: {},
  methods: {
    isLink(action) {
      return /^https?:\/\//.test(action);
    },
    isEmail(action) {
      return /^mailto:/.test(action);
    },
    isPhone(action) {
      return /^tel:/.test(action);
    },
    isRestart(action) {
      return /^restart$/.test(action);
    },
    onButtonClick(action, id) {
      if (this.$store.state.lock) return;

      if (this.isRestart(action)) {
        this.$store.dispatch("lockApp");

        this.$SmoothScroll(0, 250, () => {
          this.$store.dispatch("restart");
          this.$store.commit("CHECKHEIGHT");
          this.$store.dispatch("unlockApp");
        });
      } else {
        setTimeout(() => {
          this.$emit("onButtonClick");
          this.$store.commit("SCROLLTRIGGER");

          const clusterIndex = this.clusterIndex;
          this.$store.dispatch("lockApp");
          this.$store.dispatch("onButtonClick", { action, id, clusterIndex });
        }, 300);
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.button {
  @include device-from($device-tiny) {
    position: relative;

    font-family: $font;
    font-size: 4.5vmin;
    letter-spacing: $font-spacing;

    background-color: $color-button-content;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 2px solid $color-button-content-underline;
    color: $color-button-content-text;

    padding: 0.3em .5em 0.3em 0.5em;
    outline: none;
    cursor: pointer;
    display: inline-flex;
    text-decoration: none;
    backface-visibility: hidden;
    transform-style: preserve-3d;

    .button-vspace{
      visibility: hidden;
      width: 0;
    }

    .button-hspace{
      visibility: hidden;
    }

    .button-label{
      position: absolute;
      top:0;
      left:0;
      width: 100%;
      height:100%;
      display:flex;
      align-items: center;
      justify-content: center;
    }

    .hover{
      position: absolute;
      top:0;
      left:0;
      width: 100%;
      height: 100%;
      transform-origin: bottom left;
      transform: scaleY(0);

    }

    .hover0{
      transition: .2s .0s;
      background-color: $color-button-content-hover0;
    }

    .hover1{
      transition: .2s .1s;
      background-color: $color-button-content-hover1;
    }

    .hover2{
      transition: .2s .2s;
      background-color: $color-button-content-hover2;
    }

    margin: 5px;
   
    $base-selector: &;

    &:hover {
      //background-color: darken($color-button-content, 15);
      color: $color-button-content-text;

      .hover0, .hover1, .hover2{
        transform: scaleY(1);
      }
    }

    &--back {
      background-color: $color-button-back;
      color: $color-button-back-text;
      border-bottom: 2px solid $color-button-back-underline;

      .hover0{
        transition: .2s .0s;
        background-color: $color-button-back-hover0;
      }

      .hover1{
        transition: .2s .1s;
        background-color: $color-button-back-hover1;
      }

      .hover2{
        transition: .2s .2s;
        background-color: $color-button-back-hover2;
      }
    }


    &--link {
      background-color: $color-button-link;
      color: $color-button-link-text;
      border-bottom: 2px solid $color-button-link-underline;

      .hover0{
        transition: .2s .0s;
        background-color: $color-button-link-hover0;
      }

      .hover1{
        transition: .2s .1s;
        background-color: $color-button-link-hover1;
      }

      .hover2{
        transition: .2s .2s;
        background-color: $color-button-link-hover2;
      }

      &:hover {
        color: $color-button-link-text-hover;
      }
    }


    &--clicked {
      background-color: transparent;
      color: $color-button-back-text;

      &:hover {
        color: $color-button-back-text;
      }
    }
  }

  @include device-from($device-small) {
    & {
      font-size: 4vmin;
    }
  }

  @include device-from($device-medium) {
    & {
      font-size: 2.5vmin;
    }
  }

  @include device-from($device-large) {
    & {
      font-size: 2.5vmin;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QueryButton.vue